import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { Subscription } from "rxjs";
import { ComboEntry } from "src/model/class/general classes/combo-entry";
import { StaticClass } from "src/components/shared-components/class/general-classes/static-classes";
import { ConnectionType } from "src/components/shared-components/enum/enumSettings";
import { iConnToolbarColour } from "src/components/shared-components/interfaces/iConnToolbarColour";
import { iEvent } from "src/components/shared-components/interfaces/iEvent";
import { EventService } from "src/service/event.service";
import { NetworkService } from "src/service/network.service";

@Component({
    selector: "app-search-combo",
    templateUrl: "./search-combo.component.html",
    styleUrls: ["./search-combo.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SearchComboComponent implements OnInit, iConnToolbarColour, iEvent {
  private _networkServiceSubscription: Subscription = null;

  @Input("") ArrayComboEntries: Array<ComboEntry>;
  localArrayComboEntries: Array<ComboEntry>;

  public _eventSubscriptions: Array<Subscription> = null;
  public connectionType = ConnectionType;
  public currentConnectionType: ConnectionType = ConnectionType.NONE;

  public toolBarColor: string = "primary";

  constructor(
    private _modalController: ModalController,
    private _networkService: NetworkService,
    private _eventService: EventService
  ) { }

  ngOnInit() {
    this.subscribeNetworkServiceData();
    this.subscribeEvents();
    this.localArrayComboEntries = this.ArrayComboEntries;
  }

  ngOnDestroy() {
    this._networkServiceSubscription.unsubscribe();
    this.unsubscribeEvents();
  }

  //#region Subscribe to event-service observable
  subscribeEvents(): void {
    this._eventSubscriptions = new Array<Subscription>();

    this._eventSubscriptions.push(
      this._eventService.OnMakeForceLogout.subscribe(() => {
        this._modalController.dismiss();
      })
    );
  }

  unsubscribeEvents(): void {
    for (let sub of this._eventSubscriptions) {
      sub.unsubscribe();
    }
  }
  //#endregion

  /**
   * Subscribe to the public Observable of "NetworkService", which emits each time the connection change of type/state. A local property is changed to
   * reflect the new value.
   */
  private subscribeNetworkServiceData(): void {
    this._networkServiceSubscription =
      this._networkService.currentConnectionType.subscribe(
        (currentConnectionType: ConnectionType) => {
          this.currentConnectionType = currentConnectionType;

          this.toolBarColor = StaticClass.getComponentColorByNetworkState(
            this.currentConnectionType
          );
        }
      );
  }

  getItems(ev: any) {
    // set val to the value of the searchbar
    const val = ev.target.value;
    // if the value is an empty string don't filter the items
    if (val && val.trim() != "") {
      this.localArrayComboEntries = this.ArrayComboEntries.filter((item) => {
        return item.value.toLowerCase().indexOf(val.toLowerCase()) > -1;
      });
    } else {
      this.localArrayComboEntries = this.ArrayComboEntries;
    }
  }

  async onClick(obj: object) {
    //comm = this.commessaService.searchCommessa(commessa);
    this._modalController.dismiss(obj, "ok");
  }
}
